import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const fetchCategoriesAttributes = async (categoryId) => {
  const response = await axiosInstance.get(
    `/categories/${categoryId}/attributes/`
  );
  return response.data;
};

export const useGetCategoriesAttributes = (categoryId, options = {}) => {
  const { data, error, isLoading, isError, refetch } = useQuery({
    queryKey: ['categories', categoryId, 'attributes'],
    queryFn: () => fetchCategoriesAttributes(categoryId),
    enabled: (options.enabled ?? true) && !!categoryId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });

  return { attributes: data, error, isLoading, isError, refetch };
};
